import { useRoutes } from "react-router-dom";

import { Documents } from "../../modules/noAuth/Pages/Documents";
import FindNearestFixiter from "../../modules/noAuth/Pages/FindNearestFixiter";
import { UserRegistration } from "../../modules/noAuth/Pages/UserRegistration";
import { FixiterRegistration } from "../../modules/noAuth/Pages/FixiterRegistration";

function RegistrationRoutes() {
  const openRoutes = useRoutes([
    { path: "/find", element: (<FindNearestFixiter />) },
    { path: "/registration/:token", element: (<UserRegistration />) },
    { path: "/fixiter/registration", element: (<FixiterRegistration />) },
    { path: "/docs/:type", element: (<Documents />) },
  ])

  return openRoutes;
}

export default RegistrationRoutes;
